var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status",class:_vm.isActive ? 'status--active' : 'status--inactive'},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.isActive ? _vm.activleLabel : _vm.inactiveLabel)+" ")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }